import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger);
export default function act(){
  if(window.innerWidth > 640){
    const pin = document.getElementById('actSidebar')
    const wrap = document.getElementById('actWrapper')
    const head = document.getElementById('site-header')
    if(pin && wrap){
      ScrollTrigger.create({
        trigger: wrap,
        pin: pin,
        start: "top top",
        end: () => "+=" + (wrap.offsetHeight - pin.offsetHeight - head.offsetHeight),
        scrub: 1,
        invalidateOnRefresh: true,
        pinnedContainer: wrap,
        onEnter: () => pin.classList.add('active'),
        onLeaveBack: () => pin.classList.remove('active'),
      })
    }
  }
}